'use client';

import '@/app/globals.scss';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { getByArea } from "@/lib/offers";
import PopUpOffers from "@/components/blocks/PopUpOffers";
import dynamic from "next/dynamic";
import DialogueHeader from './dialogue/DialogueHeader';

const Dialogue = dynamic(() => import("@/components/Dialogue"), { ssr: false });

function OffersPopUpContainer() {
    const [cookies, setCookie] = useCookies(['hasVisited', 'location']);
    const [showModal, setShowModal] = useState(false);
    const [offers, setOffers] = useState<any>(null);
    const [location, setLocation] = useState<string | null>(cookies.location ?? null);

    // Fetch location from headers if the cookie isn't available
    useEffect(() => {
        if (!cookies.location) {
            fetch('/api/location') // This API route will return the header value
                .then(res => res.json())
                .then(data => {
                    if (data.location) {
                        setCookie('location', data.location, { path: '/', maxAge: 2592000, secure: true, sameSite: 'lax' }); // Store for 30 days
                        setLocation(data.location);
                    } else {
                        setLocation('World');
                    }
                })
                .catch(() => setLocation('World'));
        }
    }, [cookies, setCookie]);

    useEffect(() => {
        if (!cookies.hasVisited && location) {
            const options = { headers: { 'EO-LOCATION': location } };
            getByArea('popup', options).then(offersData => {
                if (offersData.length > 0) {
                    setOffers(offersData);
                    setShowModal(true);
                }

                setCookie('hasVisited', 'true', { path: '/', maxAge: offersData.length > 0 ? 2592000 : 86400, secure: true, sameSite: 'lax' });
            });
        }
    }, [cookies.hasVisited, location, setCookie]);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <div>
            {showModal && (
                <Dialogue open={showModal} onClose={handleCloseModal}>
                    <DialogueHeader title={"Today's Offers"} onClose={handleCloseModal} />
                    {offers && <PopUpOffers offers={offers} />}
                </Dialogue>
            )}
        </div>
    );
}

export default OffersPopUpContainer;
